module.exports = __webpack_public_path__ + "static/img/navbar_3.0632e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_3.png
// module id = EnHw
// module chunks = 25